import { Button, Form, Input, Space } from 'antd';
import { FC } from 'react';

import { ButtonSuccess } from '../../../../../common/components';
import { AppFormProps } from '../../../../../common/interfaces';
import { defineInputStatus } from '../../../../../common/utils';
import { DomainRegistrarFormFields, DomainRegistrarsFormInputs } from '../../../domainRegistrars.interfaces';

interface Props extends AppFormProps<typeof DomainRegistrarsFormInputs, DomainRegistrarFormFields> {}

export const DomainRegistrarsFormView: FC<Props> = ({
  formName,
  formType,
  form,
  initialValues,
  formErrors,
  isFormLoading,
  validationSchema,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      name={ formName }
      initialValues={ initialValues }
      autoComplete="off"
      layout="vertical"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item
        label="Назва"
        name={ DomainRegistrarsFormInputs.Name }
        hasFeedback
        help={ formErrors?.name }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.name) }
        rules={ validationSchema.name }
      >
        <Input disabled={ isFormLoading } allowClear/>
      </Form.Item>

      <Form.Item
        label="Посилання"
        name={ DomainRegistrarsFormInputs.Link }
        hasFeedback
        help={ formErrors?.link }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.link) }
        rules={ validationSchema.link }
      >
        <Input disabled={ isFormLoading } allowClear/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button disabled={ isFormLoading } type="default" onClick={ handleBack }>
            Скасувати
          </Button>
          <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
            { formType === 'edit' ? 'Зберегти' : 'Створити' }
          </ButtonSuccess>
        </Space>
      </Form.Item>
    </Form>
  );
};
